// import { useEffect, useState } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import { Box, TextField, Button, Container, Typography, Grid, AppBar, Toolbar, Paper, CircularProgress, Divider } from '@mui/material';
// import CitySearchInput from "../components/CitySearchInput";
// import FloatingLabelInput from "../components/FloatingLabelInput";
// import { useAuth } from '../context/AuthContext';

// export default function RegisterCompany({ connectionString }) {
//     // Inside RegisterCompany component:
//     const location = useLocation();
//     const pendingFromLogin = location.state?.pendingUser;
//     const pendingPassword = location.state?.password;
//     const userName = pendingFromLogin.UserName;
//     const Uid = pendingFromLogin.UserId;
//     const AppRegID = pendingFromLogin?.AppRegID || null;
//     console.log(pendingPassword, userName, Uid);
//     const { user, selectedCompany, loading, login } = useAuth(); // ← YOU SAID NEVER CHANGE THIS
//     const path = connectionString;
//     const navigate = useNavigate();

//     // === FIXED: Get user data properly from pending login or current user ===
//     const pendingLogin = JSON.parse(localStorage.getItem("pendingCompanyUser") || "{}");
//     const currentUser = pendingLogin.user || user;
//     const userId = currentUser?.UserId || null;
//     // const AppRegID = currentUser?.AppRegID || null;
//     const userPassword = pendingLogin.password || currentUser?.Password || '';

//     // === ALL YOUR STATES (unchanged) ===
//     const [companyName, setCompanyName] = useState("");
//     const [address, setAddress] = useState("");
//     const [area, setArea] = useState("");
//     const [city, setCity] = useState("");
//     const [stateField, setStateField] = useState("");
//     const [stateCode, setStateCode] = useState("");
//     const [pincode, setPincode] = useState("");
//     const [country, setCountry] = useState("India");
//     const [contactPerson, setContactPerson] = useState("");
//     const [mobileno, setMobileno] = useState("");
//     const [website, setWebsite] = useState("");
//     const [emailId, setEmailId] = useState("");
//     const [currency, setCurrency] = useState("");
//     const [gstInno, setGstInno] = useState("");
//     const [adharno, setAdharno] = useState("");
//     const [tanno, setTanno] = useState("");
//     const [panno, setPanno] = useState("");
//     const [msmeno, setMsmeno] = useState("");
//     const [cinno, setCinno] = useState("");
//     const [ielicno, setIelicno] = useState("");
//     const [postalAddress, setPostalAddress] = useState("");
//     const [branchId, setBranchId] = useState("");
//     const [groupOfCompanyId, setGroupOfCompanyId] = useState("");

//     const [gstLookupLoading, setGstLookupLoading] = useState(false);
//     const [gstValid, setGstValid] = useState(true); // ← THIS WAS MISSING
//     const [gstError, setGstError] = useState("");
//     const [errorMessage, setErrorMessage] = useState("");
//     const [successMessage, setSuccessMessage] = useState("");

//     // === FINAL SUBMIT — FIXED EVERYTHING ===
//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setErrorMessage("");
//         setSuccessMessage("");

//         if (!companyName.trim() || !contactPerson.trim() || !mobileno.trim() || !emailId.trim()) {
//             setErrorMessage("Company Name, Contact Person, Email and Mobile are required.");
//             return;
//         }

//         const payload = {
//             AppRegID,
//             companyName: companyName.trim(),
//             address: address.trim() || null,
//             area: area.trim() || null,
//             city: city.trim() || null,
//             state: stateField.trim() || null,
//             stateCode: stateCode.trim() || null,
//             pincode: pincode ? Number(pincode) : null,
//             country: country.trim() || "India",
//             contactPerson: contactPerson.trim(),
//             mobileno: mobileno.trim(),
//             website: website.trim() || null,
//             emailId: emailId.trim(),
//             currency: currency.trim() || null,
//             userName: userName,
//             password: pendingPassword,
//             gstInno: gstInno.trim() || null,
//             adharno: adharno.trim() || null,
//             tanno: tanno.trim() || null,
//             panno: panno.trim() || null,
//             msmeno: msmeno.trim() || null,
//             cinno: cinno.trim() || null,
//             ielicno: ielicno.trim() || null,
//             postalAddress: postalAddress.trim() || null,
//             branchId: branchId || null,
//             groupOfCompanyId: groupOfCompanyId || null,
//             addUserId: Uid
//         };

//         console.log("Payload: ", payload);

//         try {
//             const res = await axios.post(`${path}/api/companyMaster`, payload);

//             if (res.data.success) {
//                 localStorage.removeItem("pendingCompanyUser");

//                 const companyId = res.data.companyId;
//                 const companies = res.data.companies || [{ CompId: companyId, companyName }];

//                 // === UPDATE AUTH CONTEXT PROPERLY ===
//                 const updatedUser = {
//                     ...currentUser,
//                     CompId: companyId,
//                     companyId: companyId
//                 };

//                 login(updatedUser, companies);

//                 setSuccessMessage("Company registered successfully!");
//                 setTimeout(() => navigate("/BestCRM"), 1000);
//             } else {
//                 setErrorMessage(res.data.message || "Registration failed");
//             }
//         } catch (err) {
//             setErrorMessage(err.response?.data?.message || "Server error. Try again.");
//         }
//     };

//     // === GST LOOKUP — FULLY WORKING ===
//     const Fn_HandleGSTBlur = async () => {
//         const gst = gstInno.trim();
//         if (gst.length !== 15) return;

//         const regex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
//         if (!regex.test(gst)) {
//             setGstError("Invalid GST format");
//             return;
//         }

//         setGstLookupLoading(true);
//         setGstError("");

//         try {
//             const { data } = await axios.get(`${path}/api/gst-lookup`, { params: { searchGstin: gst } });
//             const d = data.data || {};

//             setCompanyName(d.clientName || "");
//             setContactPerson(d.contactPerson || "");
//             setAddress(d.address || "");
//             setCity(d.city || "");
//             setArea(d.landMark || d.street || "");
//             setPincode(d.PinCode ? String(d.PinCode) : "");
//             setCountry(d.Country || "India");
//             setMobileno(d.mobileNo || "");
//             setEmailId(d.emailId || "");
//             setStateField(d.state || "");
//             setStateCode(d.stateCode || gst.slice(0, 2));
//         } catch (err) {
//             setGstError("Invalid or inactive GSTIN");
//             // Clear fields on error
//             setCompanyName(""); setAddress(""); setCity(""); setArea(""); setPincode(""); setMobileno(""); setEmailId("");
//         } finally {
//             setGstLookupLoading(false);
//         }
//     };

//     if (loading) return <Box sx={{ display: 'flex', justifyContent: 'center', mt: 20 }}><CircularProgress /></Box>;

//     return (
//         <Box>
//             {/* Ribbon Header */}
//             <AppBar position="static" sx={{ bgcolor: "white", boxShadow: 3 }}>
//                 <Toolbar>
//                     <Container maxWidth="md" sx={{ display: 'flex', justifyContent: 'center' }}>
//                         <Box component="img" src="/Nexon_CRM_Final.svg" alt="Logo" sx={{ height: 38, }} />
//                     </Container>
//                 </Toolbar>
//             </AppBar>

//             {/* Main Registration Content */}
//             <Box sx={{ p: 4 }}>
//                 <Paper sx={{ maxWidth: 800, mx: "auto", p: 4 }} elevation={3}>
//                     <Typography variant="h4" gutterBottom textAlign="center">
//                         Company Registration
//                     </Typography>

//                     <Divider sx={{ my: 2 }} />

//                     <form onSubmit={handleSubmit}>
//                         {/* Company Registration Section */}
//                         <Grid container spacing={2}>
//                             {/* GST IN Field with Lookup */}
//                             <Grid item xs={12} md={6}>
//                                 <TextField
//                                     label="GST IN *"
//                                     variant="outlined"
//                                     fullWidth
//                                     value={gstInno}
//                                     onChange={(e) => {
//                                         const val = e.target.value.toUpperCase();
//                                         if (/^[A-Z0-9]{0,15}$/.test(val)) {
//                                             setGstInno(val);
//                                             setGstError("");
//                                             setGstValid(true);
//                                         }
//                                     }}
//                                     onBlur={Fn_HandleGSTBlur}
//                                     error={!!gstError}
//                                     helperText={gstError || (gstLookupLoading ? "Looking up..." : "15-digit GSTIN")}
//                                     size="small"
//                                     inputProps={{ maxLength: 15 }}
//                                     sx={{ '& .MuiInputBase-root': { height: 38 } }}
//                                     InputProps={{
//                                         endAdornment: gstLookupLoading && (
//                                             <CircularProgress size={20} />
//                                         ),
//                                     }}
//                                 />
//                             </Grid>
//                             <Grid item xs={12} md={6}>
//                                 <TextField label="Company Name *" variant="outlined" fullWidth value={companyName} onChange={(e) => setCompanyName(e.target.value)} size="small" sx={{ '& .MuiInputBase-root': { height: 38 }, }} />
//                             </Grid>
//                             <Grid item xs={12} md={6}>
//                                 <TextField label="Email ID" variant="outlined" fullWidth value={emailId} onChange={(e) => setEmailId(e.target.value)} size="small" sx={{ '& .MuiInputBase-root': { height: 38 }, }} />
//                             </Grid>
//                             <Grid item xs={12} md={6}>
//                                 <TextField label="Aadhar No" variant="outlined" fullWidth value={adharno} onChange={e => setAdharno(e.target.value)} size="small" sx={{ '& .MuiInputBase-root': { height: 38 } }} />
//                             </Grid>
//                             {/* OUTER: full-width item */}
//                             <Grid item xs={12} pt={2} pl={2}>
//                                 {/* INNER: container for the row of two halves */}
//                                 <Grid container spacing={2}>
//                                     {/* LEFT HALF */}
//                                     <Grid item xs={12} md={6}>
//                                         <TextField label="Address" multiline minRows={3.4} variant="outlined" fullWidth value={address} onChange={e => setAddress(e.target.value)} size="small"
//                                             sx={{
//                                                 '& .MuiInputBase-root:not(.MuiInputBase-multiline)': { height: 38 },
//                                                 '& .MuiOutlinedInput-inputMultiline': {
//                                                     padding: '8px 12px',
//                                                     minHeight: '80px',
//                                                 }
//                                             }}
//                                         />
//                                     </Grid>

//                                     {/* RIGHT HALF: also an item (xs=6) and a container for its own column */}
//                                     <Grid item xs={12} md={6} container direction="column" spacing={2}>
//                                         <Grid item>
//                                             <TextField label="PAN No" variant="outlined" fullWidth value={panno} onChange={(e) => setPanno(e.target.value)} size="small" sx={{ '& .MuiInputBase-root': { height: 38 }, }} />
//                                         </Grid>
//                                         <Grid item>
//                                             <TextField label="TAN No" variant="outlined" fullWidth value={tanno} onChange={e => setTanno(e.target.value)} size="small" sx={{ '& .MuiInputBase-root': { height: 38 } }} />
//                                         </Grid>
//                                     </Grid>
//                                 </Grid>
//                             </Grid>
//                             {/* If this block itself needs to be half width in an outer grid, wrap it: */}
//                             <Grid item xs={12} md={6}>
//                                 {/* Now define your two-column container */}
//                                 <Grid container spacing={1}>
//                                     <Grid item xs={6}>
//                                         <TextField label="Area" variant="outlined" fullWidth value={area} onChange={e => setArea(e.target.value)} size="small" sx={{ '& .MuiInputBase-root': { height: 38 } }} />
//                                     </Grid>
//                                     <Grid item xs={6}>
//                                         <TextField
//                                             label="Pincode"
//                                             variant="outlined" fullWidth value={pincode} type="text" // Use text instead of number for strict control
//                                             onChange={(e) => {
//                                                 const val = e.target.value;
//                                                 // Allow only digits and max 6 characters
//                                                 if (/^\d{0,6}$/.test(val)) {
//                                                     setPincode(val);
//                                                 }
//                                             }}
//                                             size="small"
//                                             sx={{ '& .MuiInputBase-root': { height: 38 } }}
//                                             inputProps={{
//                                                 inputMode: 'numeric', // Shows numeric keypad on mobile
//                                                 pattern: '[0-9]*',    // Ensures digits only
//                                                 maxLength: 6,         // Enforced on text input
//                                             }}
//                                         />


//                                     </Grid>
//                                 </Grid>
//                             </Grid>
//                             <Grid item xs={12} md={6}>
//                                 <TextField label="MSME No" variant="outlined" fullWidth value={msmeno} onChange={(e) => setMsmeno(e.target.value)} size="small" sx={{ '& .MuiInputBase-root': { height: 38 }, }} />
//                             </Grid>
//                             {/* City Field using the custom CitySearchInput */}

//                             {/* City (25%) */}
//                             <Grid item xs={12} md={6}>
//                                 <CitySearchInput value={city} fullWidth size="small" sx={{ '& .MuiInputBase-root': { height: 38 } }} connectionString={connectionString}
//                                     onSelectCity={cityObj => {
//                                         setCity(cityObj.city);
//                                         setStateField(cityObj.state);
//                                         setStateCode(cityObj.stateCode);
//                                     }}
//                                 />
//                             </Grid>
//                             <Grid container xs={12} md={6} spacing={0.5} pl={2} pt={2}>
//                                 <Grid item xs={9.5} pt={1}>
//                                     <FloatingLabelInput label="State" name="state" type="text" value={stateField} disabled fullWidth size="small" sx={{ '& .MuiInputBase-root': { height: 38 } }} />
//                                 </Grid>
//                                 <Grid item xs={2.5} pt={1}>
//                                     <FloatingLabelInput label="State Code" name="stateCode" type="text" value={stateCode} disabled fullWidth size="small" sx={{ '& .MuiInputBase-root': { height: 38 } }} />
//                                 </Grid>
//                             </Grid>
//                             <Grid item xs={12} md={6}>
//                                 <TextField label="Country" variant="outlined" fullWidth value={country} onChange={(e) => setCountry(e.target.value)} size="small" sx={{ '& .MuiInputBase-root': { height: 38 }, }} />
//                             </Grid>
//                             <Grid item xs={12} md={6}>
//                                 <TextField label="CIN No" variant="outlined" fullWidth value={cinno} onChange={(e) => setCinno(e.target.value)} size="small" sx={{ '& .MuiInputBase-root': { height: 38 }, }} />
//                             </Grid>
//                             <Grid item xs={12} md={6}>
//                                 <TextField label="Contact Person *" variant="outlined" fullWidth value={contactPerson} onChange={(e) => setContactPerson(e.target.value)} size="small" sx={{ '& .MuiInputBase-root': { height: 38 }, }} />
//                             </Grid>
//                             <Grid item xs={12} md={6}>
//                                 <TextField label="I.E. No" variant="outlined" fullWidth value={ielicno} onChange={(e) => setIelicno(e.target.value)} size="small" sx={{ '& .MuiInputBase-root': { height: 38 }, }} />
//                             </Grid>
//                             <Grid item xs={12} md={6} container direction="column" spacing={2}>
//                                 <Grid item>
//                                     <TextField label="Mobile Number *" variant="outlined" fullWidth value={mobileno} onChange={(e) => setMobileno(e.target.value)} size="small" sx={{ '& .MuiInputBase-root': { height: 38 }, }} />
//                                 </Grid>
//                                 <Grid item>
//                                     <TextField label="Website" variant="outlined" fullWidth value={website} onChange={(e) => setWebsite(e.target.value)} size="small" sx={{ '& .MuiInputBase-root': { height: 38 }, }} />
//                                 </Grid>
//                             </Grid>
//                             {/* Optional Company Fields */}
//                             <Grid item xs={12} md={6}>
//                                 <TextField label="Postal Address" multiline
//                                     minRows={2.8} variant="outlined" fullWidth value={postalAddress} onChange={(e) => setPostalAddress(e.target.value)} sx={{
//                                         '& .MuiInputBase-root:not(.MuiInputBase-multiline)': { height: 38 },
//                                         '& .MuiOutlinedInput-inputMultiline': {
//                                             padding: '8px 12px',
//                                             minHeight: '80px',
//                                         }
//                                     }} />
//                             </Grid>
//                         </Grid>

//                         <Divider sx={{ my: 2 }} />

//                         {errorMessage && (<Typography variant="body2" color="error" sx={{ mt: 2 }}> {errorMessage} </Typography>)}
//                         {successMessage && (<Typography variant="body2" color="success.main" sx={{ mt: 2 }}> {successMessage} </Typography>)}

//                         <Box sx={{ mt: 4, textAlign: "center" }}>
//                             {/* Grid container for button layout */}
//                             <Grid container spacing={2} direction={{ xs: "column", sm: "row" }} justifyContent="center">
//                                 {/* Register Button */}
//                                 <Grid item>
//                                     <Button variant="contained" color="primary" type="submit"> Register </Button>
//                                 </Grid>
//                             </Grid>
//                         </Box>
//                     </form>

//                 </Paper>
//             </Box>
//         </Box>
//     );
// }















import { colors as themeColors } from '../utils/theme';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Box, TextField, Button, Container, Typography, Paper, Divider, CircularProgress, Snackbar, Alert, InputAdornment, Grid, IconButton } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import CitySearchInput from "../components/CitySearchInput";
import FloatingLabelInput from "../components/FloatingLabelInput";
import { useAuth } from '../context/AuthContext';
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import BusinessIcon from '@mui/icons-material/Business';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import BadgeIcon from '@mui/icons-material/Badge';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';

// ── Design tokens (Facebook blue · grey 200 · arctic white) ──
const RC = {
    blue: themeColors.primary.main, blueDark: themeColors.primary.dark, tint: '#E7F0FE',
    ink: themeColors.neutral.ink, sub: themeColors.neutral.sub, mute: themeColors.neutral.muted,
    line: '#E4E6EB', hover: '#F0F2F5', page: '#F5F7FA', white: themeColors.neutral.surface,
    green: '#16a34a', red: '#E53935',
};

// Shared input look (display only)
const rcField = (multiline = false) => ({
    '& .MuiInputBase-root': {
        height: multiline ? 'auto' : 44, alignItems: 'center', borderRadius: '10px', bgcolor: '#FAFBFC',
        transition: 'background-color .2s ease, box-shadow .2s ease',
        '& fieldset': { borderColor: RC.line, transition: 'border-color .2s ease' },
        '&:hover fieldset': { borderColor: RC.blue },
        '&.Mui-focused': { bgcolor: themeColors.neutral.surface, boxShadow: '0 0 0 4px rgba(24,119,242,0.12)' },
        '&.Mui-focused fieldset': { borderColor: RC.blue, borderWidth: 2 },
    },
    '& .MuiInputBase-input': { padding: '10px 14px' },
});

// Section card: icon + title header, fields in a responsive grid
const RcSection = ({ icon, title, hint, delay = 0, single = false, children }) => (
    <Box sx={{
        bgcolor: RC.white, border: `1px solid ${RC.line}`, borderRadius: 3,
        boxShadow: '0 1px 2px rgba(15,23,42,0.04), 0 6px 18px rgba(15,23,42,0.04)',
        animation: 'rcRise .5s cubic-bezier(.33,0,.2,1) ' + delay + 's backwards',
    }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, px: 2.5, py: 1.75, borderBottom: `1px solid ${RC.line}` }}>
            <Box sx={{ width: 34, height: 34, borderRadius: 2, bgcolor: RC.tint, color: RC.blue, display: 'flex', alignItems: 'center', justifyContent: 'center', '& svg': { fontSize: 19 } }}>
                {icon}
            </Box>
            <Box sx={{ minWidth: 0 }}>
                <Typography sx={{ color: RC.ink, fontWeight: 700, fontSize: '0.98rem', lineHeight: 1.25 }}>{title}</Typography>
                {hint && <Typography sx={{ color: RC.sub, fontSize: '0.78rem' }}>{hint}</Typography>}
            </Box>
        </Box>
        <Box sx={{ p: 2.5, display: 'grid', gridTemplateColumns: single ? 'minmax(0, 1fr)' : { xs: 'minmax(0, 1fr)', md: 'repeat(2, minmax(0, 1fr))' }, gap: 2 }}>
            {children}
        </Box>
    </Box>
);

const RegisterCompany = ({ connectionString }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const { user, loading, login } = useAuth();

    const pendingFromLogin = location.state?.pendingUser;
    const pendingPassword = location.state?.password;
    const userName = pendingFromLogin?.UserName;
    const Uid = pendingFromLogin?.UserId;
    const AppRegID = pendingFromLogin?.AppRegID || null;

    const pendingLogin = JSON.parse(localStorage.getItem("pendingCompanyUser") || "{}");
    const currentUser = pendingLogin.user || user;
    const userPassword = pendingLogin.password || currentUser?.Password || '';

    const [showPassword, setShowPassword] = useState({ eway: false, einvoice: false, });

    const API = connectionString;

    const [formState, setFormState] = useState({
        gstInno: "", companyName: "", address: "", area: "", pincode: "", city: "", state: "", stateCode: "", country: "India",
        contactPerson: "", mobileno: "", emailId: "", website: "", adharno: "", tanno: "", panno: "", msmeno: "",
        cinno: "", ielicno: "", postalAddress: "", EWBUserName: "", EWBPassword: "", EIUserName: "", EIPassword: "", BkName1: "", BkBranch1: "", BkAcNo1: "", BkIFSCCode1: ""
    });

    const [gstLookupLoading, setGstLookupLoading] = useState(false);
    const [gstError, setGstError] = useState("");
    const [gstFetched, setGstFetched] = useState(false);

    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formError, setFormError] = useState("");

    const [selectedCity, setSelectedCity] = useState(null);
    const [cityQuery, setCityQuery] = useState("");
    const [errors, setErrors] = useState({});

    const requiredAsteriskStyle = { '& .MuiFormLabel-asterisk': { color: 'red', }, };

    const togglePassword = (key) => { setShowPassword((prev) => ({ ...prev, [key]: !prev[key], })); };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormState(prev => ({ ...prev, [name]: value }));
    };

    const handleBlur = (e) => {
        const { name, value } = e.target;
        let errorMsg = "";

        // Account No
        if (name === "BkAcNo1" && value) {
            if (!/^\d+$/.test(value)) {
                errorMsg = "Only digits allowed";
            } else if (value.length < 9 || value.length > 18) {
                errorMsg = "9 to 18 digits required";
            }
        }

        // IFSC
        if (name === "BkIFSCCode1" && value) {
            const isValidLength = value.length === 11;
            const hasLetter = /[A-Za-z]/.test(value);
            const hasDigit = /\d/.test(value);
            const isAlphanumeric = /^[A-Za-z0-9]+$/.test(value);

            if (!isValidLength) {
                errorMsg = "Must be 11 characters";
            } else if (!isAlphanumeric) {
                errorMsg = "Only letters & digits allowed";
            } else if (!hasLetter || !hasDigit) {
                errorMsg = "Must contain letter & digit";
            }
        }

        setErrors(prev => ({ ...prev, [name]: errorMsg }));
    };

    // const handleGstChange = (e) => {
    //     let value = e.target.value.toUpperCase();
    //     if (!/^[A-Z0-9]{0,15}$/.test(value)) return;
    //     setFormState(prev => ({ ...prev, gstInno: value }));
    //     setGstError("");
    //     setGstFetched(false);
    // };

    const handleGstChange = (e) => {
        let value = e.target.value.toUpperCase();
        if (!/^[A-Z0-9]{0,15}$/.test(value)) return;
        setFormState(prev => ({ ...prev, gstInno: value }));
        setGstError("");
        // Don't reset gstFetched here - only validate format
    };

    // const Fn_HandleGSTBlur = async () => {
    //     const gst = formState.gstInno.trim();
    //     if (gst.length !== 15) return;

    //     const regex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    //     if (!regex.test(gst)) {
    //         setGstError("Invalid GST format");
    //         return;
    //     }

    //     setGstLookupLoading(true);
    //     setGstError("");

    //     try {
    //         const { data } = await axios.get(`${API}/api/gst-lookup`, { params: { searchGstin: gst } });
    //         const d = data.data || {};

    //         setFormState(prev => ({
    //             ...prev,
    //             companyName: d.clientName || "",
    //             contactPerson: d.contactPerson || "",
    //             address: d.address || "",
    //             city: d.city || "",
    //             area: d.landMark || d.street || "",
    //             pincode: d.PinCode ? String(d.PinCode) : "",
    //             country: d.Country || "India",
    //             mobileno: d.mobileNo || "",
    //             emailId: d.emailId || ""
    //         }));

    //         if (d.city) {
    //             const cityObj = {
    //                 city: d.city,
    //                 state: d.state,
    //                 stateCode: d.stateCode || gst.slice(0, 2),
    //                 country: d.Country || "India"
    //             };
    //             setSelectedCity(cityObj);
    //             setCityQuery(d.city);
    //         }

    //         setGstFetched(true);
    //         setSnackbar({ open: true, message: "GST details fetched successfully", severity: "success" });
    //     } catch (err) {
    //         setGstError("Invalid or inactive GSTIN");
    //         setFormState(prev => ({
    //             ...prev,
    //             companyName: "", address: "", city: "", area: "", pincode: "", mobileno: "", emailId: ""
    //         }));
    //         setSelectedCity(null);
    //         setCityQuery("");
    //         setGstFetched(false);
    //     } finally {
    //         setGstLookupLoading(false);
    //     }
    // };

    const handleGstAutoFill = async () => {
        const gst = formState.gstInno.trim();
        if (gst.length !== 15) {
            setGstError("Please enter a valid 15-character GST No");
            return;
        }

        const regex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
        if (!regex.test(gst)) {
            setGstError("Invalid GST format");
            return;
        }

        setGstLookupLoading(true);
        setGstError("");

        try {
            const { data } = await axios.get(`${API}/api/gst-lookup`, { params: { searchGstin: gst } });
            const d = data.data || {};

            console.log("gst", d)

            setFormState(prev => ({
                ...prev,
                companyName: d.clientName || "",
                contactPerson: d.contactPerson || "",
                address: d.address || "",
                city: d.city || "",
                area: d.Area || d.landMark || d.street || '',
                pincode: d.PinCode ? String(d.PinCode) : "",
                country: d.Country || "India",
                mobileno: d.mobileNo || "",
                emailId: d.emailId || "",
                state: d.State,
                stateCode: d.stateCode || gst.slice(0, 2),
            }));

            if (d.city) {
                const cityObj = { city: d.city, state: d.state, stateCode: d.stateCode || gst.slice(0, 2), country: d.Country || "India" };
                setSelectedCity(cityObj);
                setCityQuery(d.city);
            }

            setGstFetched(true);
            setSnackbar({ open: true, message: "GST details fetched successfully", severity: "success" });
        } catch (err) {
            setGstError("Invalid or inactive GSTIN");
            setFormState(prev => ({ ...prev, companyName: "", address: "", city: "", area: "", pincode: "", mobileno: "", emailId: "", state: "", stateCode: "" }));
            setSelectedCity(null);
            setCityQuery("");
            setGstFetched(false);
        } finally {
            setGstLookupLoading(false);
        }
    };

    const handleCitySelect = (cityObj) => {
        setSelectedCity(cityObj);
        setCityQuery(cityObj.city);
        setFormState(prev => ({ ...prev, city: cityObj.city, state: cityObj.state, stateCode: cityObj.stateCode, country: cityObj.country || "India" }));
    };

    const validate = () => {
        if (!formState.companyName.trim() || !formState.contactPerson.trim() || !formState.emailId.trim()) {
            setFormError("Company Name, Contact Person and Email are required.");
            return false;
        }
        setFormError("");
        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;

        setIsSubmitting(true);
        setFormError("");

        const payload = {
            AppRegID,
            companyName: formState.companyName.trim(),
            address: formState.address.trim() || null,
            area: formState.area.trim() || null,
            city: formState.city.trim() || null,
            state: formState.state.trim() || null,
            stateCode: formState.stateCode.trim() || null,
            pincode: formState.pincode ? Number(formState.pincode) : null,
            country: formState.country.trim() || "India",
            contactPerson: formState.contactPerson.trim(),
            mobileno: formState.mobileno.trim(),
            website: formState.website.trim() || null,
            emailId: formState.emailId.trim(),
            currency: null,
            userName,
            password: pendingPassword,
            gstInno: formState.gstInno.trim() || null,
            adharno: formState.adharno.trim() || null,
            tanno: formState.tanno.trim() || null,
            panno: formState.panno.trim() || null,
            msmeno: formState.msmeno.trim() || null,
            cinno: formState.cinno.trim() || null,
            ielicno: formState.ielicno.trim() || null,
            postalAddress: formState.postalAddress.trim() || null,
            branchId: null,
            groupOfCompanyId: null,
            addUserId: Uid,
            EWBUserName: formState.EWBUserName,
            EWBPassword: formState.EWBPassword,
            EIUserName: formState.EIUserName,
            EIPassword: formState.EIPassword,
            BkName1: formState.BkName1 || null,
            BkBranch1: formState.BkBranch1 || null,
            BkAcNo1: formState.BkAcNo1 || null,
            BkIFSCCode1: formState.BkIFSCCode1 || null,
        };

        try {
            const res = await axios.post(`${API}/api/companyMaster`, payload);

            if (res.data.success) {
                localStorage.removeItem("pendingCompanyUser");

                const companyId = res.data.companyId;
                const companies = res.data.companies || [{ CompId: companyId, companyName: formState.companyName }];
                const updatedUser = { ...currentUser, CompId: companyId, companyId: companyId };
                login(updatedUser, companies);

                setSnackbar({ open: true, message: "Company registered successfully!", severity: "success" });
                setTimeout(() => navigate("/NexonCRM"), 1500);
            } else {
                setFormError(res.data.message || "Registration failed");
                setSnackbar({ open: true, message: res.data.message || "Registration failed", severity: "error" });
            }
        } catch (err) {
            const msg = err.response?.data?.message || "Server error. Try again.";
            setFormError(msg);
            setSnackbar({ open: true, message: msg, severity: "error" });
        } finally {
            setIsSubmitting(false);
        }
    };

    const renderField = (label, name, required = false, multiline = false) => (
        <TextField fullWidth label={label} name={name} size="small" value={formState[name]} onChange={handleChange} onBlur={handleBlur} error={!!errors[name]} helperText={errors[name] || ''} required={required} multiline={multiline} minRows={multiline ? 2.6 : undefined}
            sx={{
                ...(required ? requiredAsteriskStyle : {}),
                ...rcField(multiline),
            }}
        />
    );

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 20 }}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Box className="rc-root" sx={{ bgcolor: RC.page, borderRadius: 3, p: { xs: 1.5, sm: 3 }, mt: 1 }}>
            <style>{[
                "@import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@400;500;600;700&display=swap');",
                ".rc-root, .rc-root * { font-family: 'IBM Plex Sans', -apple-system, 'Segoe UI', Roboto, sans-serif !important; }",
                "@keyframes rcRise { from { opacity: 0; transform: translate3d(0, 8px, 0); } to { opacity: 1; transform: translate3d(0, 0, 0); } }",
                "@keyframes rcFade { from { opacity: 0; } to { opacity: 1; } }",
                "@keyframes rcPop { 0% { transform: scale(.7); opacity: 0; } 70% { transform: scale(1.1); } 100% { transform: scale(1); opacity: 1; } }",
            ].join("\n")}</style>

            <Box sx={{ maxWidth: 1040, mx: 'auto' }}>

                {/* Header */}
                <Box sx={{ mb: 3, animation: 'rcRise .5s cubic-bezier(.33,0,.2,1) backwards' }}>
                    <Typography sx={{ color: RC.blue, fontSize: '0.74rem', fontWeight: 700, letterSpacing: '1.6px', textTransform: 'uppercase' }}>
                        Account setup
                    </Typography>
                    <Typography sx={{ color: RC.ink, fontWeight: 700, fontSize: { xs: '1.6rem', sm: '2rem' }, letterSpacing: '-0.8px', lineHeight: 1.15, mt: 0.75 }}>
                        Company Registration
                    </Typography>
                    <Typography sx={{ color: RC.sub, fontSize: '0.95rem', mt: 0.75 }}>
                        Add your company details to get started. Fields marked * are required.
                    </Typography>
                </Box>

                <form onSubmit={handleSubmit}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>

                        {/* Business identity */}
                        <RcSection icon={<BusinessIcon />} title="Business identity" hint="Verify your GSTIN to auto-fill the details below." delay={0.04}>
                            <TextField
                                label="GST IN"
                                name="gstInno"
                                value={formState.gstInno}
                                onChange={handleGstChange}
                                fullWidth
                                size="small"
                                inputProps={{ maxLength: 15 }}
                                error={!!gstError}
                                helperText={gstError}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            {gstFetched && <CheckCircleIcon sx={{ color: RC.green, fontSize: 20, mr: 1, animation: 'rcPop .35s ease' }} />}
                                            <Button
                                                variant="outlined"
                                                size="small"
                                                onClick={handleGstAutoFill}
                                                disabled={gstLookupLoading || formState.gstInno.length !== 15}
                                                sx={{
                                                    height: 32,
                                                    mr: -1,
                                                    fontSize: '0.75rem',
                                                    fontWeight: 600,
                                                    textTransform: 'none',
                                                    padding: '4px 12px',
                                                    borderRadius: '8px',
                                                    borderColor: RC.line,
                                                    color: RC.blue,
                                                    '&:hover': { borderColor: RC.blue, bgcolor: RC.tint },
                                                }}
                                            >
                                                {gstLookupLoading ? <CircularProgress size={16} sx={{ mr: 0.5 }} /> : 'Verify'}
                                            </Button>
                                        </InputAdornment>
                                    ),
                                }}
                                sx={rcField()}
                            />
                            {renderField("Company Name", "companyName", true)}
                        </RcSection>

                        {/* Address */}
                        <RcSection icon={<LocationOnIcon />} title="Address" hint="Where your company is located." delay={0.08}>
                            <Box sx={{ gridColumn: '1 / -1' }}>{renderField("Address", "address", false, true)}</Box>
                            <Box display="flex" gap={2}>
                                <Box flex={1}>{renderField("Area", "area")}</Box>
                                <Box flex={1}>
                                    <TextField
                                        label="Pincode"
                                        name="pincode"
                                        value={formState.pincode}
                                        required
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            if (/^\d{0,6}$/.test(val)) {
                                                setFormState(prev => ({ ...prev, pincode: val }));
                                            }
                                        }}
                                        fullWidth
                                        size="small"
                                        inputProps={{ maxLength: 6, inputMode: 'numeric' }}
                                        InputLabelProps={{
                                            sx: {
                                                '& .MuiFormLabel-asterisk': {
                                                    color: 'red',
                                                },
                                            },
                                        }}
                                        sx={rcField()}
                                    />
                                </Box>
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 1 }}>
                                <Box flex={1} sx={{ '&& .MuiInputBase-root': { height: 44, borderRadius: '10px' } }}>
                                    <CitySearchInput
                                        value={selectedCity?.city || cityQuery}
                                        connectionString={connectionString}
                                        onSelectCity={handleCitySelect}
                                        onChangeQuery={(q) => {
                                            setCityQuery(q);
                                            setSelectedCity(null);
                                        }}
                                        fullWidth
                                        size="small"
                                        sx={{ '& .MuiInputBase-root': { height: 44, borderRadius: '10px' } }}
                                    />
                                </Box>
                                <Box display="flex" flex={1} gap={1}>
                                    <Box flex={0.6}>
                                        <FloatingLabelInput
                                            label="State"
                                            value={formState.state}
                                            disabled
                                            required
                                            fullWidth
                                            size="small"
                                            InputLabelProps={{ sx: requiredAsteriskStyle }}
                                            sx={{ height: 44, '& .MuiInputBase-root': { height: 44, borderRadius: '10px' } }}
                                        />
                                    </Box>
                                    <Box flex={0.4}>
                                        <FloatingLabelInput
                                            label="State Code"
                                            value={formState.stateCode}
                                            disabled
                                            required
                                            fullWidth
                                            size="small"
                                            InputLabelProps={{ sx: requiredAsteriskStyle }}
                                            sx={{ height: 44, '& .MuiInputBase-root': { height: 44, borderRadius: '10px' } }}
                                        />
                                    </Box>
                                </Box>
                            </Box>
                            <TextField
                                fullWidth
                                label="Country"
                                name="country"
                                value={formState.country}
                                disabled
                                required
                                size="small"
                                InputLabelProps={{ sx: requiredAsteriskStyle }}
                                sx={rcField()}
                            />
                            <Box sx={{ gridColumn: '1 / -1' }}>{renderField("Postal Address", "postalAddress", false, true)}</Box>
                        </RcSection>

                        {/* Contact */}
                        <RcSection icon={<ContactPhoneIcon />} title="Contact" hint="Who we should reach out to." delay={0.12}>
                            {renderField("Contact Person", "contactPerson", true)}
                            {renderField("Mobile Number", "mobileno", false)}
                            {renderField("Email ID", "emailId", true)}
                            {renderField("Website", "website")}
                        </RcSection>

                        {/* Statutory details */}
                        <RcSection icon={<BadgeIcon />} title="Statutory details" hint="Tax and registration numbers (optional)." delay={0.16}>
                            {renderField('PAN No.', 'panno', false, false, { xs: 12, md: 12 }, { sx: { mb: 1.3 } })}
                            {renderField('Aadhar No.', 'adharno', false, false, { xs: 12, md: 12 }, { sx: { mb: 1.3 } })}
                            {renderField("TAN No", "tanno")}
                            {renderField("MSME No", "msmeno")}
                            {renderField("CIN No", "cinno")}
                            {renderField("I.E. No", "ielicno")}
                        </RcSection>

                        {/* E-Way Bill & E-Invoice credentials */}
                        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 2.5 }}>
                            <RcSection icon={<LocalShippingIcon />} title="E-Way Bill" hint="Portal login for e-way bills." delay={0.2} single>
                                <TextField
                                    fullWidth
                                    label="Username"
                                    name="EWBUserName"
                                    size="small"
                                    value={formState.EWBUserName || ''}
                                    onChange={handleChange}
                                    sx={rcField()}
                                />
                                <TextField
                                    fullWidth
                                    label="Password"
                                    name="EWBPassword"
                                    type={showPassword.eway ? "text" : "password"}
                                    size="small"
                                    value={formState.EWBPassword || ''}
                                    onChange={handleChange}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={() => togglePassword("eway")}
                                                    edge="end"
                                                    size="small"
                                                >
                                                    {showPassword.eway ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                    sx={rcField()}
                                />
                            </RcSection>

                            <RcSection icon={<ReceiptLongIcon />} title="E-Invoice" hint="Portal login for e-invoicing." delay={0.24} single>
                                <TextField
                                    fullWidth
                                    label="Username"
                                    name="EIUserName"
                                    size="small"
                                    value={formState.EIUserName || ''}
                                    onChange={handleChange}
                                    sx={rcField()}
                                />
                                <TextField
                                    fullWidth
                                    label="Password"
                                    name="EIPassword"
                                    type={showPassword.einvoice ? "text" : "password"}
                                    size="small"
                                    value={formState.EIPassword || ''}
                                    onChange={handleChange}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={() => togglePassword("einvoice")}
                                                    edge="end"
                                                    size="small"
                                                >
                                                    {showPassword.einvoice ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                    sx={rcField()}
                                />
                            </RcSection>
                        </Box>

                        {/* Bank details */}
                        <RcSection icon={<AccountBalanceIcon />} title="Bank details" hint="Printed on your invoices (optional)." delay={0.28}>
                            {renderField('Bank Name', 'BkName1')}
                            {renderField('Branch', 'BkBranch1')}
                            {renderField('Account No', 'BkAcNo1')}
                            {renderField('IFSC Code', 'BkIFSCCode1')}
                        </RcSection>
                    </Box>

                    {/* Sticky action bar */}
                    <Box sx={{
                        position: 'sticky', bottom: 0, zIndex: 4, mt: 3, mx: { xs: -1.5, sm: -3 }, mb: { xs: -1.5, sm: -3 },
                        px: { xs: 2, sm: 3 }, py: 1.5,
                        bgcolor: 'rgba(255,255,255,0.94)', backdropFilter: 'blur(8px)',
                        borderTop: `1px solid ${RC.line}`, borderRadius: '0 0 12px 12px',
                        display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2,
                    }}>
                        <Box sx={{ minWidth: 0 }}>
                            {formError ? (
                                <Typography sx={{ color: RC.red, fontSize: '0.86rem', fontWeight: 600, animation: 'rcFade .25s ease' }}>
                                    {formError}
                                </Typography>
                            ) : (
                                <Typography sx={{ color: RC.sub, fontSize: '0.82rem', display: { xs: 'none', sm: 'block' } }}>
                                    Review your details, then register your company.
                                </Typography>
                            )}
                        </Box>
                        <Button
                            type="submit"
                            variant="contained"
                            disableElevation
                            disabled={isSubmitting}
                            startIcon={isSubmitting ? <CircularProgress size={18} sx={{ color: 'inherit' }} /> : null}
                            sx={{
                                minWidth: 160, height: 46, borderRadius: '10px', textTransform: 'none', fontWeight: 700, fontSize: '0.95rem', whiteSpace: 'nowrap',
                                background: `linear-gradient(135deg, ${RC.blue} 0%, ${RC.blueDark} 100%)`,
                                boxShadow: '0 6px 18px rgba(24,119,242,0.3)',
                                transition: 'transform .2s ease, box-shadow .2s ease',
                                '&:hover': { boxShadow: '0 10px 24px rgba(24,119,242,0.42)', transform: 'translateY(-2px)' },
                                '&:active': { transform: 'translateY(0) scale(.99)' },
                                '&.Mui-disabled': { background: RC.hover, color: RC.mute, boxShadow: 'none' },
                            }}
                        >
                            Register
                        </Button>
                    </Box>
                </form>
            </Box>

            <Snackbar
                open={snackbar.open}
                autoHideDuration={5000}
                onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert
                    onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
                    severity={snackbar.severity}
                    sx={{ width: '100%' }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Box>
    );
};

export default RegisterCompany;